/**
 *
 * The nav duck. Default export is the reducer.
 *
 * Action Types:
 * - NAV_OPENED
 * - NAV_CLOSED
 *
 * Action Creators:
 * - navRequest
 * - navSucceeded
 * - openNav
 * - closeNav
 */
import { PACKAGES_FETCH_REQUESTED } from './packages';

// import type {
//   NavAction,
//   NavClosed,
//   NavFinished,
//   NavNode,
//   NavOpened,
//   NavState,
// } from '../types';

/** @type {ActionType} **/
export const NAV_FINISHED = 'PB/nav/NAV_FINISHED';

/** @type {ActionType} */
export const NAV_OPENED = 'PB/nav/NAV_OPENED';

/** @type {ActionType} */
export const NAV_CLOSED = 'PB/nav/NAV_CLOSED';

export const initialState = {
  open: false,
  data: undefined,
};

/** @ignore */
export default function nav(
  state: NavState = initialState,
  action: NavAction,
): NavState {
  switch (action.type) {
    case NAV_OPENED:
      return { ...state, open: true };

    case PACKAGES_FETCH_REQUESTED:
    case NAV_FINISHED:
    case NAV_CLOSED:
      return { ...state, open: false };

    default:
      return state;
  }
}

export function navFinished(href: string, path: Array<string>): NavFinished {
  return {
    type: NAV_FINISHED,
    payload: { href, path },
  };
}

export function openNav(): NavOpened {
  return {
    type: NAV_OPENED,
  };
}

export function closeNav(): NavClosed {
  return {
    type: NAV_CLOSED,
  };
}
